(() => {
  if (window.Shopify?.designMode) return;

  const connection = navigator.connection;
  if (connection?.saveData || /(?:slow-)?2g/.test(connection?.effectiveType || '')) return;

  const paths = new Set(['/pages/neon-editor', '/pages/neon-canvas', '/pages/get-a-quote']);
  const prefetched = new Set();
  let pending;

  const destination = target => {
    const anchor = target.closest?.('a[href]');
    if (!anchor) return null;
    const url = new URL(anchor.href, location.href);
    if (url.origin !== location.origin || !paths.has(url.pathname) || url.search || url.pathname === location.pathname) return null;
    return url;
  };

  const prefetch = url => {
    if (document.readyState !== 'complete' || prefetched.size >= 2 || prefetched.has(url.pathname)) return;
    prefetched.add(url.pathname);
    const hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.as = 'document';
    hint.href = url.href;
    document.head.append(hint);
  };

  document.addEventListener('pointerover', event => {
    const url = destination(event.target);
    if (!url || event.pointerType === 'touch') return;
    clearTimeout(pending);
    pending = setTimeout(() => prefetch(url), 100);
  }, { passive: true });
  document.addEventListener('pointerout', event => {
    const from = event.target.closest?.('a[href]');
    const to = event.relatedTarget?.closest?.('a[href]');
    if (from !== to) clearTimeout(pending);
  }, { passive: true });
  document.addEventListener('focusin', event => {
    const url = destination(event.target);
    if (url) prefetch(url);
  });
})();
